// dependencies
import React, { useState } from 'react'
// helpers
import { addToDataLayer } from '@helpers/google-tag-manager'
import AddToCartModalComponent from '../product/product-parts/add-to-cart-modal'

// eslint-disable-next-line import/prefer-default-export
export function useCart({
  index,
  PLP,
  product,
  isYMALItem,
  price,
  stockMessage,
  addons,
  requiredSelected,
  activeAddons,
  promoDescription,
  promoItems,
  promoQualifierQuantity,
  promoTargetQuantity,
  promoTargetPrice,
  promoStrikethroughPrice,
  warrantyEnabled,
  componentPage,
  quantity,
  source,
}) {
  const [showAddToCartModal, setShowAddToCartModal] = useState(false)

  const onAddToCart = event => {
    event?.preventDefault?.()
    addToDataLayer('click', componentPage, 'add to cart', product.sku)
    if (!showAddToCartModal) {
      setShowAddToCartModal(true)
    }
  }

  const renderAddToCartModal = () =>
    showAddToCartModal ? (
      <AddToCartModalComponent
        pageName={PLP}
        quantity={quantity}
        modalOpen={showAddToCartModal && !isYMALItem}
        product={product}
        price={price}
        closeModal={() => setShowAddToCartModal(false)}
        stockMessage={stockMessage}
        addons={addons}
        requiredSelected={requiredSelected}
        activeAddons={activeAddons}
        index={index}
        promoDescription={promoDescription}
        promoItems={promoItems}
        promoQualifierQuantity={promoQualifierQuantity}
        promoTargetQuantity={promoTargetQuantity}
        promoTargetPrice={promoTargetPrice}
        promoStrikethroughPrice={promoStrikethroughPrice}
        warrantyEnabled={warrantyEnabled}
        source={source}
      />
    ) : (
      <div />
    )

  return {
    renderAddToCartModal,
    onAddToCart,
  }
}
